'use client';
import { useEffect, useState } from 'react';
import { DialogTrigger } from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import { TranslateText } from '@/helpers/utils/siteUtils';
import { DEFAULT_SITE_LANG } from '../../../../../constants/constant';
import { NOTES_HEADER_KEYS, NOTES_RECORD_KEYS } from '../../customer-detail/constants';
import { PageTexts } from '../../customer-detail/i18n';
import { FormattedNote } from '../../customer-detail/types';
import { Table, TableColumnConfig } from '../../ui/customTable/Table';
import { Dialog, DialogClose, DialogContent, DialogHeader, DialogTitle } from '../../ui/dialog';
import NoteModal from '../orderDetails/addNewNote';

export const OrderNotesTableHeadersData: TableColumnConfig<any>[] = [
  {
    key: NOTES_RECORD_KEYS.AGENT,
    header: NOTES_HEADER_KEYS.AGENT,
    render: (data) => <div className="gbmask">{data?.split('@')?.[0]}</div>,
  },
  {
    key: NOTES_RECORD_KEYS.DATE_TIME,
    header: NOTES_HEADER_KEYS.ORDER_DATE_TIME,
    render: (data) => {
      return <div className="whitespace-nowrap">{data}</div>;
    },
  },
  {
    key: NOTES_RECORD_KEYS.NOTES,
    header: NOTES_HEADER_KEYS.NOTES,
    render: (data) => <div className="gbmask">{data}</div>,
  },
];

const ViewAllNotesModals = ({
  customerNotes,
  noteOptions,
  addNewNotes,
  isCustomerDetailsPage = false,
  getNotes,
  setCustomerNotes,
  setAllCustomerNotes,
  setTotalItems,
  showActiveBrandSection = true,
}: {
  customerNotes: FormattedNote[];
  noteOptions: any;
  addNewNotes: any;
  isCustomerDetailsPage?: boolean;
  getNotes?: any;
  setCustomerNotes?: any;
  setAllCustomerNotes?: any;
  setTotalItems?: any;
  showActiveBrandSection?: boolean;
}) => {
  const Texts = TranslateText(PageTexts, DEFAULT_SITE_LANG);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (isCustomerDetailsPage && open) {
      getNotes(undefined, true);
    }
  }, [isCustomerDetailsPage, open]);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger>{Texts.viewAllNotes}</DialogTrigger>
      <DialogContent
        showClose={false}
        className="custom-scrollbar max-h-[90%] max-w-[762px] overflow-y-auto bg-white sm:rounded-md"
      >
        <DialogHeader className="flex">
          {/* chng-text-25px */}
          <DialogTitle className="mt-2 flex items-center text-2xl font-bold">
            <div className="mr-auto text-2xl font-bold">
              {Texts.viewAllNotes} {`(${customerNotes?.length})`}
            </div>
            {showActiveBrandSection && (
              <div className="mr-6">
                <NoteModal
                  Texts={Texts}
                  flag={isCustomerDetailsPage ? false : true}
                  isCustomerDetailsPage={isCustomerDetailsPage}
                  noteOptions={noteOptions}
                  addNewNotes={addNewNotes}
                  setCustomerNotes={setCustomerNotes}
                  setAllCustomerNotes={setAllCustomerNotes}
                  setTotalItems={setTotalItems}
                  isViewAll={true}
                />
              </div>
            )}

            <DialogClose className="ring-offset-background focus:ring-ring data-[state=open]:bg-accent data-[state=open]:text-muted-foreground  rounded-sm opacity-70 transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:pointer-events-none">
              <X className="h-4 w-4" />
              <span className="sr-only">Close</span>
            </DialogClose>
          </DialogTitle>
        </DialogHeader>
        <Table columns={OrderNotesTableHeadersData} data={customerNotes} />
      </DialogContent>
    </Dialog>
  );
};

export default ViewAllNotesModals;
